/**
 * @file Cart Body
 */

import { gsap } from 'gsap';
import scrollTo from 'gsap/ScrollToPlugin';

/**
 * Cart Body component
 */
const vCartBody = () => {
	const cartBody = document.querySelector('.v-cart-body');

	if (!cartBody) {
		return;
	}

	const wpcf7       = cartBody.querySelector( '.wpcf7' );

	// Bail out if WPCF7 form not present
	if ( ! wpcf7 ) {
		return;
	}

	gsap.registerPlugin(scrollTo);

	const emptySection     = cartBody.querySelector('.v-cart__section--empty');
	const tableBody        = cartBody.querySelector('.v-cart__products-table-body');
	const cartItemTemplate = cartBody.querySelector('.v-cart-body__item-template');
	const cart             = JSON.parse(localStorage.getItem('ccsp-cart') || '[]');
	// const maskOptions      = {
	// 	mask: Number,
	// 	scale: 0,
	// 	min: 0,
	// 	max: 999,
	// };
	const maskedInputs     = cartBody.querySelectorAll('.v-cart__masked-input');
	const fileInputs       = cartBody.querySelectorAll('.v-cart__upload-input');
	const wpcf7Response    = cartBody.querySelector( '.wpcf7-response-output' );
	const thankYouSection  = cartBody.querySelector('.v-cart-body__thanks');
	const form             = wpcf7.querySelector( 'form' );
	const hiddenInput      = form.querySelector('.v-cart__hidden-items');
	const elbLayer         = window.elbLayer || [];
	const numOfColorsInputs 		 = cartBody.querySelectorAll('input[type="number"].v-cart__colors-input');

	/**
	 * Triggers DOM changes when cart is empty
	 */
	 const emptyCartHandler = () => {
		hiddenInput.value = JSON.stringify([]);
		emptySection.classList.remove('v-cart__section--hidden');

		[...cartBody.querySelectorAll('.v-cart__section:not(.v-cart__section--empty), .wpcf7-response-output')].forEach((section) => {
			section.classList.add('v-cart__section--hidden');
		});

		[...fileInputs].forEach((input) => {
			const parent = input.closest('.v-cart__upload-label');
			const label  = parent.querySelector('.v-cart__upload-label-text');
			input.value = '';
			label.innerText = 'Choose file';
		});

		const cartEvent = new CustomEvent('v-cart-changed', {
			detail: {
				isEmpty: true,
			},
		});
		document.dispatchEvent(cartEvent);
	};

	/**
	 * Hadles removing an item from the cart & DOM
	 *
	 * @param {Event} e The click event
	 */
	const removeItemHandler = (e) => {
		e.preventDefault();

		const item            = e.target.closest('.v-cart__products-table-row');
		const itemParent      = item.parentNode;

		// remove from local storage cart
		const itemIndex = cart.findIndex((cartItem) => {
			const itemSize = item.querySelector('.v-cart__product-size').textContent;
			const itemColor = item.querySelector('.v-cart__product-color').style.getPropertyValue('--v-product-color');

			const isMatch = (
				cartItem.styleId === item.getAttribute('data-style-id') &&
				cartItem.size === itemSize &&
				cartItem.color.includes(itemColor)
			);
			return isMatch;
		});
		cart.splice(itemIndex, 1);

		// save new cart to local storage
		const stringifiedCart = JSON.stringify(cart);
		localStorage.setItem('ccsp-cart', stringifiedCart);
		hiddenInput.value = stringifiedCart;

		// remove from DOM
		gsap.to(item, {
			duration: 0.5,
			opacity: .2,
			backgroundColor: '#ede8f0',
			onComplete: () => {
				itemParent.removeChild(item);
				if (itemParent.children.length <= 1) {
					emptyCartHandler();
				}
			}
		});
	};

	/**
	 * Builds cart item HTML
	 */
	const buildCartItem = (item, idx) => {
		const cartRow     = cartItemTemplate.content.firstElementChild.cloneNode(true);
		const removeBtn   = cartRow.querySelector('.v-cart__product-remove-btn');
		const rowThumb    = cartRow.querySelector('.v-cart__product-thumb');
		const rowTitle    = cartRow.querySelector('.v-cart__product-title');
		const rowMill     = cartRow.querySelector('.v-cart__product-mill');
		const rowStyle    = cartRow.querySelector('.v-cart__product-style-id');
		const rowSize     = cartRow.querySelector('.v-cart__product-size');
		const rowColor    = cartRow.querySelector('.v-cart__product-color');
		const rowQtyInput = cartRow.querySelector('.v-cart__product-quantity-input');
		const rowQty      = parseInt(item.quantity, 10);
		const rowId       = `item-${item.styleId}-${Math.floor(Math.random() * Date.now())}`;

		cartRow.setAttribute('data-style-id', item.styleId);
		cartRow.setAttribute('id', rowId);
		rowThumb.src = item.thumbSrc;
		rowThumb.alt = `${item.name} product thumbnail`;
		rowTitle.innerHTML = item.name;
		rowMill.innerHTML = item.mill;
		rowStyle.innerHTML = item.styleId;
		rowSize.textContent = item.size;
		rowColor.style.setProperty('--v-product-color', item.color);

		rowQtyInput.addEventListener('change', () => {
			const rowIdx = [...tableBody.querySelectorAll('.v-cart__products-table-row')].indexOf(cartRow);
			const qty    = parseInt(rowQtyInput.value, 10);
			if (!qty) {
				// if ( ! rowQtyInput.getAttribute('data-init')) {
				// 	IMask(rowQtyInput, maskOptions);
				// }

				// rowQtyInput.inputmask.setValue(cart[rowIdx].quantity);
				if (cart[rowIdx]) {
					rowQtyInput.value = parseInt(cart[rowIdx].quantity, 10);
					rowQtyInput.setAttribute('data-init', true);
					console.log(rowQtyInput, 'set to ' + parseInt(cart[rowIdx].quantity, 10));
				}
			}

			cart[rowIdx].quantity = qty;
			const stringifiedCart = JSON.stringify(cart);
			localStorage.setItem('ccsp-cart', stringifiedCart);
			hiddenInput.value = stringifiedCart;

			if (qty < 1) {
				removeBtn.click();
			}
		});

		// input listener to prevent non-numeric input
		rowQtyInput.addEventListener('input', (e) => {
			const {target} = e;
			const {value}  = target;
			const newValue = value.replace(/\D/g, '');
			target.value   = newValue;
			console.log(rowQtyInput, 'updated to ' + newValue);
		});

		removeBtn.addEventListener('click', removeItemHandler);

		// Mask input
		// const mask = IMask(rowQtyInput, maskOptions);

		// Set row quantity
		rowQtyInput.value = rowQty;
		// mask.value = item.quantity;
		// mask.typedValue = rowQty;
		// console.log(rowQtyInput, rowQtyInput.value, rowQty);

		// Set flag
		rowQtyInput.setAttribute('data-init', true);

		tableBody.appendChild(cartRow);
	};

	/**
	 * Handles file change event
	 *
	 * @param {Event} e The change event
	 */
	const fileChangeHandler = (e) => {
		const {target}    = e;
		const {files}     = target;
		const inputParent = target.closest('.v-cart__upload-label');
		const inputLabel  = inputParent.querySelector('.v-cart__upload-label-text');
		const maxWidth    = window.matchMedia('(max-width: 1240px)').matches ? 22 : 12;
		let labelText     = inputLabel.textContent;

		if (files.length > 0) {
			labelText = files[0].name;
		}

		inputLabel.textContent = labelText.length > maxWidth ? `...${labelText.slice(-(maxWidth - 1))}` : labelText;
	};

	/**
	 * Form submit handler
	 */
	const formSubmitHandler = (e) => {
		const { inputs }    = e.detail;
		const email     = [...inputs].filter(({name}) => name === 'email-address')[0].value;
		const timestamp     = new Date();
		const quoteId       = `${timestamp.getMonth() < 9 ? '0' : ''}${timestamp.getMonth() + 1}${timestamp.getDate()}${timestamp.getFullYear()}-${email.slice(0, email.indexOf('@'))}-${Date.now().toString(36)}`;
		const bodyContainer = cartBody.querySelector('.container');
		const allSections   = cartBody.querySelectorAll('.v-cart__section');

		// hide wpcf7 response
		wpcf7Response.style.display = 'none';

		// hide all sections & empty cart
		thankYouSection.style.display = 'block';
		const thankYouHeight = thankYouSection.getBoundingClientRect().height;
		thankYouSection.removeAttribute('style');

		gsap.timeline({
			defaults: {
				duration: 0.75,
				ease: 'sine.out',
				onComplete: () => {
					const cartChangedEvent = new CustomEvent('v-cart-changed', {
						detail: {
							isEmpty: true,
						}
					});

					const cartQty = cart.reduce((acc, item) => {
						return acc + parseInt(item.quantity, 10);
					}, 0);

					elbLayer.push(
						'quote submitted',
						{
							quote_id: quoteId,
							item_quantity: cartQty,
						},
						'click'
					);

					localStorage.setItem('ccsp-cart', JSON.stringify([]));

					document.dispatchEvent(cartChangedEvent);
				},
			},
		})
			.to(allSections, {
				opacity: 0,
			})
			.to(bodyContainer, {
				height: `${thankYouHeight}px`,
				onUpdate: () => {
					gsap.to(window,{
						scrollTo: {
							y: thankYouSection.getBoundingClientRect().top,
						},
					});
				},
				onComplete: () => {
					[...allSections].forEach((section) => {
						section.classList.add('v-cart__section--hidden');
					});
					thankYouSection.classList.add('v-cart-body__thanks--visible');
				},
			});
	};

	if (cart.length === 0) {
		emptyCartHandler();
	} else {
		// build cart
		[...cart].forEach((item, idx) => buildCartItem(item, idx));
		window.addEventListener('load', () => {
			setTimeout(() => {
				[...cart].forEach((item, idx) => {
					const rowQty      = parseInt(item.quantity, 10);
					const cartRow = tableBody.querySelector(`tr:nth-of-type(${idx + 1})`);
					const rowQtyInput = cartRow.querySelector('.v-cart__product-quantity-input');
					if (!rowQtyInput.value && rowQty) {
						rowQtyInput.value = rowQty;
					}
				});
			}, 0);
		});
		[...maskedInputs].forEach((input) => {
			// Mask input

			if (input.getAttribute('data-init') !== 'true') {
				// const mask = new IMask(input, maskOptions);
				// IMask(input, maskOptions);
				input.setAttribute('data-init', true);
				// mask.updateValue();
			}
		});

		// add cart contents to hidden field
		hiddenInput.value = JSON.stringify(cart);

		// add event listeners to file inputs
		[...fileInputs].forEach((input) => input.addEventListener('change', fileChangeHandler));

		// show cart
		emptySection.classList.add('v-cart__section--hidden');
		[...cartBody.querySelectorAll('.v-cart__section--hidden:not(.v-cart__section--empty)')].forEach((section) => {
			section.classList.remove('v-cart__section--hidden');
		});

		wpcf7.addEventListener('wpcf7mailsent', formSubmitHandler);

		// Enforce max length on number inputs
		if (numOfColorsInputs) {
			numOfColorsInputs.forEach(input => {
				const maxLength = 2;
				input.addEventListener('keyup', () => {
					if (input.value.length > maxLength) {
						input.value = input.value.slice(0, maxLength);
					}
				});
			});
		}
	}
};

export default vCartBody;

